import axios from 'axios';

class ApiService {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;

    this.client = axios.create({
      baseURL: this.baseUrl,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  setAuthToken(token) {
    if (token) {
      this.client.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete this.client.defaults.headers.common['Authorization'];
    }
  }

  async get(path, params = {}) {
    try {
      const response = await this.client.get(path, {params});
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async post(path, data = {}) {
    try {
      const response = await this.client.post(path, data);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async put(path, data = {}) {
    try {
      const response = await this.client.put(path, data);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async delete(path) {
    try {
      const response = await this.client.delete(path);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  handleError(error) {
    if (error.response) {
      console.error('API Error:', error.response.status, error.response.data);
      throw error.response.data;
    } else if (error.request) {
      console.error('No response from API', error.request);
      throw new Error('No response from API');
    } else {
      console.error('API Error', error.message);
      throw new Error(error.message);
    }
  }
}

// Requests go through Node.js server (production) or CRA proxy (local dev)
export const apiService = new ApiService('');
